// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b
import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { BREAK_POINT } from '../../../../constants';
import NumberDisplay from './NumberDisplay';

const RankDisplay = ({ rankName, counter, isVisible, isSmall = false }) => {
  const dimensions = isSmall
    ? {
        pc: {
          width: 41,
          height: 54,
          viewBox: '0 0 50 54',
          transform: 'translate(1 43)',
          fontSize: 37,
          subSize: 16,
        },
        mobile: {
          width: 32,
          height: 39,
          viewBox: '0 0 37 39',
          transform: 'translate(0 31)',
          fontSize: 27,
          subSize: 12,
        },
      }
    : {
        pc: {
          width: 68,
          height: 84,
          viewBox: '0 0 80 84',
          transform: 'translate(0 67)',
          fontSize: 58,
          subSize: 26,
        },
        mobile: {
          width: 41,
          height: 54,
          viewBox: '0 0 50 54',
          transform: 'translate(1 43)',
          fontSize: 37,
          subSize: 16,
        },
      };

  return (
    <div className={`${!isVisible && 'rank-visible-hidden'} ${isSmall ? 'result-de' : 'result'}`}>
      <div className={`result__rank-name ${isSmall ? 'result__rank-name_D_E' : ''}`}>
        <MediaQuery minWidth={BREAK_POINT + 1}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={dimensions.pc.width}
            height={dimensions.pc.height}
            viewBox={dimensions.pc.viewBox}
          >
            <text
              id={`${rankName}賞`}
              transform={dimensions.pc.transform}
              fill="#fff"
              fontSize={dimensions.pc.fontSize}
              fontFamily="AOTFShinMaruGoPro"
              fontWeight="700"
            >
              <tspan x="0" y="0">
                {rankName}
              </tspan>
              <tspan y="0" fontSize={dimensions.pc.subSize}>
                賞
              </tspan>
            </text>
          </svg>
        </MediaQuery>
        <MediaQuery maxWidth={BREAK_POINT}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={dimensions.mobile.width}
            height={dimensions.mobile.height}
            viewBox={dimensions.mobile.viewBox}
          >
            <text
              id={`${rankName}賞`}
              transform={dimensions.mobile.transform}
              fill="#fff"
              fontSize={dimensions.mobile.fontSize}
              fontFamily="AOTFShinMaruGoPro"
              fontWeight="700"
            >
              <tspan x="0" y="0">
                {rankName}
              </tspan>
              <tspan y="0" fontSize={dimensions.mobile.subSize}>
                賞
              </tspan>
            </text>
          </svg>
        </MediaQuery>
      </div>
      <div className="result_quantity">
        <NumberDisplay number={counter} isSmall={isSmall} />
      </div>
    </div>
  );
};

RankDisplay.propTypes = {
  rankName: PropTypes.string.isRequired,
  counter: PropTypes.number.isRequired,
  isVisible: PropTypes.bool,
  isSmall: PropTypes.bool,
};

export default RankDisplay;
